import styled from "styled-components";

import { DesignTokens, ExclamationCircleIcon } from "melco-ui";

const { colors } = DesignTokens;

const Badge = styled.div`
  background-color: ${colors.feedback.warning};
  color: ${colors.main.negative};
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WarningBadge: React.FC = () => (
  <Badge>
    <ExclamationCircleIcon />
  </Badge>
);
